import React from 'react';
import '../Colors.css';

const Bicycle = ({className, heightStyle}) => {
  return (
    <svg height={heightStyle} viewBox="0 0 283.46 283.46" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path className='Citybike' d="M89.435,126.067c12.627,10.015,20.465,25.255,20.465,42.672c0,30.48-24.384,54.864-54.864,54.864
      c-30.48,0-54.865-24.384-54.865-54.864c0-30.045,24.384-54.864,54.865-54.864c2.612,0,5.224,0,7.837,0.436l-4.79,10.886h-3.047
      c-23.949,0-43.543,19.594-43.543,43.543c0,23.949,19.594,43.543,43.543,43.543c23.948,0,43.542-19.594,43.542-43.543
      c0-12.627-5.224-23.948-13.933-31.786L89.435,126.067z M228.773,174.4h-77.071c-2.177,0-3.92-0.871-4.79-1.741l-60.089-62.702
      l-26.562,60.96c-0.87,2.177-3.047,3.484-5.224,3.484c-0.871,0-1.307,0-2.177-0.436c-3.049-1.306-4.354-4.354-3.049-7.402
      L94.66,63.365c0.871-2.177,2.613-3.484,4.79-3.484h16.546c3.484,0,5.661,2.612,5.661,5.661c0,3.048-2.177,5.66-5.661,5.66h-12.627
      l-6.096,13.499h83.602l6.096-13.934h-13.063c-5.224,0-10.45-5.661-10.45-10.886h53.993c0,5.225-5.226,10.886-10.886,10.886h-7.403
      l-13.497,32.222l47.462,62.266c1.306,1.741,1.306,3.919,0.434,6.096C232.691,173.093,230.95,174.4,228.773,174.4z
       M149.959,159.159l26.562-63.137H92.483l-0.87,2.613L149.959,159.159z M160.409,163.079h56.606l-36.576-47.898L160.409,163.079z
       M283.636,168.739c0,30.48-24.819,54.864-54.864,54.864c-25.256,0-46.592-16.982-53.123-40.059h11.757
      c6.096,16.546,22.207,28.738,41.366,28.738c23.948,0,43.542-19.594,43.542-43.543c0-23.948-19.594-43.543-43.542-43.543
      c-4.79,0-9.144,0.871-13.499,2.177l-7.403-9.579c6.531-2.613,13.499-3.919,20.901-3.919
      C258.817,113.875,283.636,138.694,283.636,168.739z M175.649,154.37c1.743-6.967,5.226-13.063,9.144-18.724l7.403,9.144
      c-2.177,3.048-3.484,6.096-4.79,9.579H175.649z"/>
    </svg>
  );
};

export default Bicycle;